import { setTranslations, setLocale, getLocale } from 'react-i18nify';
import { sv } from './sv';
import { en } from './en';
import moment from 'moment';

export const translationsObject = {
  sv,
  en
};

const browserLanguage = navigator.language.substring(0, 2);
const storedLanguageSetting = localStorage.getItem('locale');

const defaultLanguage = Object.getOwnPropertyNames(translationsObject).includes(browserLanguage)
  ? browserLanguage
  : 'sv';

if (!storedLanguageSetting) {
  localStorage.setItem('locale', defaultLanguage);
}

setTranslations(translationsObject);
setLocale(storedLanguageSetting || defaultLanguage);
moment.locale(defaultLanguage);

export const currentLocale = getLocale;
